document.documentElement.classList.remove('no-js');

const qs=(s,c=document)=>c.querySelector(s);
const qsa=(s,c=document)=>[...c.querySelectorAll(s)];

function initMobileMenu(){
  const btn=qs('[data-lj-menu-toggle]');
  const menu=qs('[data-lj-mobile-menu]');
  if(!btn||!menu)return;
  btn.addEventListener('click',()=>{
    const open=menu.classList.toggle('is-open');
    btn.setAttribute('aria-expanded',open?'true':'false');
  });
}

function money(cents,currency){
  try{return new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format((cents||0)/100)}catch(e){return ((cents||0)/100).toFixed(2)}
}

function updateLJTiers(cart,drawer){
  if(!cart||!drawer)return;
  const count=cart.item_count||0;
  const tierProgress=count>=3?100:count===2?67:count===1?34:0;
  const tierDiscount=count>=3?40:count===2?25:count===1?10:0;
  const tierStatus=qs('[data-lj-tier-status]',drawer);
  const tierBadge=qs('[data-lj-tier-badge]',drawer);
  const tierBar=qs('[data-lj-tier-progress]',drawer);
  const tierMsg=qs('[data-lj-tier-message]',drawer);
  if(tierStatus)tierStatus.textContent=tierDiscount?(tierDiscount+'% OFF unlocked'+(count>=3?' 🎉':'')):'Buy More, Save More';
  if(tierBadge)tierBadge.textContent=count>=3?'BEST DEAL':count===2?'Next: 40% OFF':count===1?'Next: 25% OFF':'Up to 40% OFF';
  if(tierBar)tierBar.style.width=tierProgress+'%';
  if(tierMsg)tierMsg.textContent=count>=3?'You unlocked the best Little Joy tier.':count===2?'Add 1 more item to unlock 40% off.':count===1?'Add 1 more item to unlock 25% off.':'Add 1 item to unlock 10% off.';
  const threshold=500000;
  const remaining=Math.max(0,threshold-(cart.total_price||0));
  const pct=Math.min(100,Math.max(0,((cart.total_price||0)/threshold)*100));
  const shipStatus=qs('[data-lj-shipping-status]',drawer);
  const shipBar=qs('[data-lj-shipping-progress]',drawer);
  const shipMsg=qs('[data-lj-shipping-message]',drawer);
  if(shipBar)shipBar.style.width=pct+'%';
  if(shipStatus)shipStatus.textContent=remaining<=0?'Free delivery unlocked 🎉':'Free Delivery above Rs. 5,000';
  if(shipMsg)shipMsg.textContent=remaining<=0?'Your order qualifies for free delivery.':('Only '+money(remaining,cart.currency)+' away from FREE delivery.');
}

async function refreshDrawer(open=true){
  const drawer=qs('[data-lj-cart-drawer]');
  if(!drawer)return;
  try{
    const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});
    const cart=await r.json();
    const items=qs('[data-lj-drawer-items]',drawer);
    const subtotal=qs('[data-lj-drawer-subtotal]',drawer);
    const countEls=qsa('[data-lj-cart-count]');
    countEls.forEach(el=>el.textContent=cart.item_count);
    if(items){
      if(!cart.items.length){items.innerHTML='<div class="lj-empty">Your cart is empty.</div>'}
      else items.innerHTML=cart.items.map(item=>`<div class="lj-drawer__item"><img src="${item.image||''}" alt=""><div class="lj-drawer__itemcopy"><strong>${item.product_title}</strong><div class="lj-drawer__variant">${item.variant_title||''}</div><div class="lj-price">${money(item.final_line_price,cart.currency)}</div></div><div class="lj-drawer__qty">x${item.quantity}</div></div>`).join('');
    }
    if(subtotal)subtotal.textContent=money(cart.total_price,cart.currency);
    updateLJTiers(cart,drawer);
    if(open){drawer.hidden=false;document.body.style.overflow='hidden'}
  }catch(e){console.warn('Little Joy cart drawer',e)}
}

function initCartDrawer(){
  const drawer=qs('[data-lj-cart-drawer]');
  if(!drawer)return;
  qsa('[data-lj-open-cart]').forEach(btn=>btn.addEventListener('click',e=>{e.preventDefault();refreshDrawer(true)}));
  qsa('[data-lj-close-cart]',drawer).forEach(btn=>btn.addEventListener('click',()=>{drawer.hidden=true;document.body.style.overflow=''}));
  qsa('form[data-ajax-product-form]').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault();
    const submit=qs('[type="submit"]',form); if(submit){submit.disabled=true;submit.dataset.oldText=submit.textContent;submit.textContent='Adding…'}
    try{
      const fd=new FormData(form);
      const r=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
      if(!r.ok)throw new Error('Could not add to cart');
      await refreshDrawer(true);
    }catch(err){alert(err.message)}
    finally{if(submit){submit.disabled=false;submit.textContent=submit.dataset.oldText||'Add to cart'}}
  }));
}

function initFilterAutosubmit(){
  qsa('[data-filter-form] input').forEach(el=>el.addEventListener('change',()=>el.form.submit()));
  qsa('[data-sort-select]').forEach(el=>el.addEventListener('change',()=>el.form.submit()));
}

function initRevealAnimations(){
  const autoTargets=[
    '.lj-hero__copy','.lj-hero__media','.lj-section-head','.lj-collection-card','.lj-product-card',
    '.lj-promo__media','.lj-promo__center','.lj-promo__right','.lj-benefit','.lj-story__media',
    '.lj-story__copy','.lj-review','.lj-instagram__head','.lj-insta-card','.lj-product-gallery','.lj-product-info',
    '.lj-banner-slide'
  ];
  autoTargets.forEach(selector=>qsa(selector).forEach(el=>{if(!el.hasAttribute('data-lj-reveal'))el.setAttribute('data-lj-reveal','')}));
  const all=qsa('[data-lj-reveal]');
  if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    all.forEach(el=>el.classList.add('is-visible'));
    return;
  }
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  },{threshold:.14,rootMargin:'0px 0px -40px 0px'});
  all.forEach(el=>observer.observe(el));
}

function initBannerSlider(){
  qsa('[data-lj-slider]').forEach(slider=>{
    const slides=qsa('[data-lj-slide]',slider);
    const dots=qsa('[data-lj-dot]',slider);
    const prev=qs('[data-lj-prev]',slider);
    const next=qs('[data-lj-next]',slider);
    if(slides.length<=1)return;
    let index=0; let timer;
    const autoplay=slider.dataset.autoplay==='true';
    const interval=parseInt(slider.dataset.interval||'5000',10);

    const show=(i)=>{
      index=(i+slides.length)%slides.length;
      slides.forEach((slide,idx)=>slide.classList.toggle('is-active',idx===index));
      dots.forEach((dot,idx)=>dot.classList.toggle('is-active',idx===index));
    };
    const start=()=>{ if(!autoplay) return; stop(); timer=setInterval(()=>show(index+1), interval); };
    const stop=()=>{ if(timer) clearInterval(timer); };

    prev?.addEventListener('click',()=>{show(index-1); start();});
    next?.addEventListener('click',()=>{show(index+1); start();});
    dots.forEach(dot=>dot.addEventListener('click',()=>{show(parseInt(dot.dataset.ljDot,10)||0); start();}));
    // Autoplay remains active while the mouse rests on the banner.
    // Keyboard focus continues to pause the carousel.
    slider.addEventListener('focusin',stop);
    slider.addEventListener('focusout',start);
    show(0); start();
  });
}

function initPopup(){
  qsa('[data-lj-popup]').forEach(popup=>{
    const showOnce=popup.dataset.showOnce==='true';
    const key='littlejoy_popup_closed';
    if(showOnce && window.sessionStorage.getItem(key)==='1') return;
    const delay=parseInt(popup.dataset.delay||'1500',10);
    const close=()=>{
      popup.hidden=true;
      document.body.style.overflow='';
      if(showOnce){try{window.sessionStorage.setItem(key,'1')}catch(e){}}
    };
    qsa('[data-lj-popup-close]',popup).forEach(el=>el.addEventListener('click',close));
    setTimeout(()=>{
      popup.hidden=false;
      document.body.style.overflow='hidden';
    },delay);
    document.addEventListener('keydown',e=>{ if(e.key==='Escape' && !popup.hidden) close(); });
  });
}

function initAdvancedProduct(){
  const section=qs('[data-lj-product-section]');
  if(!section)return;

  const jsonEl=qs('[data-lj-variants-json]',section);
  let variants=[];
  try{variants=JSON.parse(jsonEl?.textContent||'[]')}catch(e){variants=[]}

  const select=qs('[data-lj-variant-select]',section);
  const priceEl=qs('[data-lj-product-price]',section);
  const saveEl=qs('[data-lj-save-note]',section);
  const salePill=qs('[data-lj-sale-pill]',section);
  const stockPill=qs('[data-lj-stock-pill]',section);
  const atc=qs('[data-lj-atc-button]',section);
  const stickyPrice=qs('[data-lj-sticky-price]',section);
  const stickyButton=qs('[data-lj-sticky-button]',section);
  const tierOffer=qs('[data-lj-tier-offer]',section);
  const tierPreview=qs('[data-lj-tier-preview]',section);
  const qtyInput=qs('input[name="quantity"]',section);
  let activeVariantPrice=parseInt(tierOffer?.dataset.basePrice||'0',10);
  function updateTierPreview(){
    if(!tierOffer||!tierPreview)return;
    const qty=Math.max(1,parseInt(qtyInput?.value||'1',10));
    const discount=qty>=3?40:qty===2?25:10;
    const totalBefore=activeVariantPrice*qty;
    const totalAfter=Math.round(totalBefore*(1-discount/100));
    qsa('[data-lj-tier-step]',tierOffer).forEach(step=>step.classList.toggle('is-active',parseInt(step.dataset.ljTierStep,10)===(qty>=3?3:qty)));
    let extra=qty>=3?' · Best tier unlocked 🎉':(' · Add 1 more to unlock '+(qty===1?'25':'40')+'% OFF');
    tierPreview.innerHTML='<strong>'+discount+'% OFF unlocked</strong> · Estimated '+money(totalAfter,activeCurrency())+' for '+qty+' item'+(qty>1?'s':'')+extra;
  }

  function activeCurrency(){ return window.Shopify?.currency?.active || window.Shopify?.currency?.currentCurrency || 'PKR'; }

  function updateVariant(id){
    const variant=variants.find(v=>String(v.id)===String(id));
    if(!variant)return;
    const price=money(variant.price,activeCurrency());
    activeVariantPrice=parseInt(variant.price||0,10);
    const compare=variant.compare_at_price||0;
    const hasSale=compare>variant.price;
    const compareText=hasSale?money(compare,activeCurrency()):'';
    if(priceEl)priceEl.innerHTML=`${price}${hasSale?` <s>${compareText}</s>`:''}`;
    if(stickyPrice)stickyPrice.textContent=price;
    const savings=hasSale?Math.round(((compare-variant.price)/compare)*100):0;
    if(saveEl){saveEl.hidden=!hasSale;saveEl.textContent=hasSale?`You save ${savings}% on this style`:''}
    if(salePill){salePill.style.display=hasSale?'inline-flex':'none'; if(hasSale)salePill.textContent=`Save ${savings}%`}
    if(stockPill){stockPill.textContent=variant.available?'In stock':'Sold out';stockPill.classList.toggle('lj-pill--muted',!variant.available)}
    [atc,stickyButton].forEach(btn=>{if(!btn)return;btn.disabled=!variant.available;btn.textContent=variant.available?'Add to cart':'Sold out'});
    updateTierPreview();
  }

  qtyInput?.addEventListener('input',updateTierPreview);
  updateTierPreview();

  if(select && select.tagName==='SELECT'){
    select.addEventListener('change',()=>updateVariant(select.value));
    updateVariant(select.value);
  }

  if(stickyButton){
    stickyButton.addEventListener('click',()=>{ if(atc && !atc.disabled) atc.click(); });
  }

  const sticky=qs('[data-lj-sticky-atc]',section);
  const anchor=qs('[data-lj-product-form-anchor]',section);
  if(sticky && anchor && 'IntersectionObserver' in window){
    const io=new IntersectionObserver(entries=>{
      const entry=entries[0];
      sticky.classList.toggle('is-visible',!entry.isIntersecting && entry.boundingClientRect.top<0);
    },{threshold:.1});
    io.observe(anchor);
  }

  const modal=qs('[data-lj-image-modal]',section);
  const modalImg=qs('[data-lj-image-modal-img]',section);
  const modalClose=qs('[data-lj-image-modal-close]',section);
  qsa('[data-lj-product-image]',section).forEach(btn=>btn.addEventListener('click',()=>{
    const img=qs('img',btn); if(!img||!modal||!modalImg)return;
    modalImg.src=img.currentSrc||img.src; modalImg.alt=img.alt||'';
    if(typeof modal.showModal==='function')modal.showModal();
  }));
  if(modalClose && modal)modalClose.addEventListener('click',()=>modal.close());
  if(modal)modal.addEventListener('click',e=>{if(e.target===modal)modal.close()});
}


function initQuickAdd(){
  const modal=qs('[data-lj-quick-modal]');
  const content=qs('[data-lj-quick-content]',modal||document);
  if(!modal||!content)return;

  const close=()=>{
    modal.hidden=true;
    content.innerHTML='';
    document.body.style.overflow='';
  };

  qsa('[data-lj-quick-close]',modal).forEach(el=>el.addEventListener('click',close));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!modal.hidden)close()});

  qsa('[data-lj-quick-add-trigger]').forEach(btn=>btn.addEventListener('click',()=>{
    const templateId=btn.dataset.templateId;
    const template=document.getElementById(templateId);
    if(!template)return;
    content.innerHTML='';
    content.appendChild(template.content.cloneNode(true));
    modal.hidden=false;
    document.body.style.overflow='hidden';

    const form=qs('[data-lj-quick-form]',content);
    const select=qs('[data-lj-quick-variant-select]',content);
    const priceEl=qs('[data-lj-quick-price]',content);
    const quickQty=qs('input[name="quantity"]',content);
    const quickTierNote=qs('[data-lj-quick-tier-note]',content);

    const currency=window.Shopify?.currency?.active || window.Shopify?.currency?.currentCurrency || 'PKR';
    const updateQuickPrice=()=>{
      if(!select||!priceEl)return;
      const option=select.options[select.selectedIndex];
      if(!option)return;
      const price=parseInt(option.dataset.price||'0',10);
      const compare=parseInt(option.dataset.compare||'0',10);
      priceEl.innerHTML=`${money(price,currency)}${compare>price?` <s>${money(compare,currency)}</s>`:''}`;
    };
    const updateQuickTier=()=>{
      if(!quickTierNote)return;
      const qty=Math.max(1,parseInt(quickQty?.value||'1',10));
      const discount=qty>=3?40:qty===2?25:10;
      quickTierNote.textContent=qty>=3?'40% OFF unlocked — best deal 🎉':(discount+'% OFF unlocked · Add 1 more item to unlock '+(qty===1?'25':'40')+'% OFF');
    };
    select?.addEventListener('change',updateQuickPrice);
    quickQty?.addEventListener('input',updateQuickTier);
    updateQuickPrice();
    updateQuickTier();

    form?.addEventListener('submit',async e=>{
      e.preventDefault();
      const submit=qs('[type="submit"]',form);
      if(submit){submit.disabled=true;submit.dataset.oldText=submit.textContent;submit.textContent='Adding…'}
      try{
        const fd=new FormData(form);
        const r=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
        if(!r.ok){
          const err=await r.json().catch(()=>({}));
          throw new Error(err.description||'Could not add this product to cart');
        }
        close();
        await refreshDrawer(true);
      }catch(err){
        alert(err.message||'Could not add this product to cart');
      }finally{
        if(submit){submit.disabled=false;submit.textContent=submit.dataset.oldText||'Add to Cart'}
      }
    });
  }));
}

document.addEventListener('DOMContentLoaded',()=>{
  initMobileMenu();
  initCartDrawer();
  initFilterAutosubmit();
  initRevealAnimations();
  initBannerSlider();
  initPopup();
  initAdvancedProduct();
  initQuickAdd();
});
